import ApiBase from "../api-base";

class MeetingsApi extends ApiBase {
    async getMyBookings(params = {}) {
        const response = await this.get(`/meeting-room-bookings`, { ...params });

        return response.data;
    }



    async getAddons() {
        const response = await this.get('/add-on-categories');

        return response.data;
    }

    async getMeetingRooms(params) {
        const response = await this.get(`/meeting-rooms`, params);

        return response.data;
    }

    async getMeetingRoom(id) {
        const response = await this.get(`/meeting-rooms/${id}`);

        return response.data;
    }

    async getMeetingRoomBooking(id) {
        const response = await this.get(`/meeting-room-bookings/${id}`);

        return response.data;
    }

    async getBuilding(id) {
        return this.handleResponse(async () => {
            let response = await this.get(`/admin/office-buildings/${id}`);
            return response.data;
        });
    }

    async getCalendarAvailability(id, params) {
        return this.handleResponse(async () => {
            let response = await this.get(`/meeting-rooms/${id}/calendar-availability`, params);
            return response.data;
        });
    }

    async getCalendarDayAvailability(id, params) {
        return this.handleResponse(async () => {
            let response = await this.get(`/meeting-rooms/${id}/day-availability`, params);
            return response.data;
        });
    }

    async getDaySchedule(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/schedule/day`, params, validationHandler);
            return response.data;
        });
    }

    async getWeekSchedule(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/schedule/week`, params, validationHandler);
            return response.data;
        });
    }

    async getMonthSchedule(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/schedule/month`, params, validationHandler);
            return response.data;
        });
    }

    async addAdditionalRequirementsToAddon(id, addonId, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/${id}/addon-bookings/${addonId}/additional-requirements`, params, validationHandler);
            return response.data;
        });
    }

    async addAttendeeToBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/${id}/add-attendee`, params, validationHandler);
            return response.data;
        });
    }

    async removeAttendeeToBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async  () => {
            let response = await this.post(`/meeting-room-bookings/${id}/remove-attendee`, params, validationHandler);
            return response.data;
        });
    }

    async createMeetingRoomBooking(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/meeting-room-bookings`, params, validationHandler, false);

            return response.data.data;
        });
    }

    async updateMeetingRoomBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/meeting-room-bookings/${id}`, params, validationHandler, false);

            return response.data.data;
        });
    }

    async getBookingQuoteCancellation(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/meeting-room-bookings/${id}/quote-cancellation`, params, validationHandler, false);

            return response.data;
        });
    }

    async cancelMeetingRoomBooking(id, params, validationHandler = this.validationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/meeting-room-bookings/${id}/cancel`, params, validationHandler, false);

            return response.data.data;
        });
    }

    async getBookingQuote(params, validationHandler = this.validationHandler) {
        return this.handleResponse(async () => {
            const response = await this.post(`/meeting-room-bookings/quote`, params, validationHandler, false);

            return response.data;
        });
    }
}

export default new MeetingsApi();
